module.exports = __webpack_public_path__ + "img/sepa_debit-square.eaf4d3ba.svg";